import React from 'react';
import {
  Box,
  Paper,
  Button,
  Typography,
} from '@mui/material';
import {
  Microsoft as MicrosoftIcon,
} from '@mui/icons-material';
import { logDebug } from '../utils/errorLogger';
import CascadeIcon from './CascadeIcon';

interface LoginProps {
  onLogin: (success: boolean) => void;
  returnUrl?: string;
}

const Login: React.FC<LoginProps> = ({ returnUrl }) => {
  // Debug logging
  logDebug('Login component rendered', { returnUrl });

  const handleSsoLogin = () => {
    // Redirect to SSO login endpoint (handled by ASP.NET backend)
    // Pass the returnUrl so the backend can redirect back to the original page after authentication
    const loginUrl = returnUrl 
      ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
      : '/login';
    
    logDebug('Redirecting to SSO login', { loginUrl, returnUrl });
    window.location.href = loginUrl;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #42a5f5 0%, #1976d2 100%)', // Light blue to primary blue (matches logo)
        padding: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          padding: 4,
          width: '100%',
          maxWidth: 400,
          borderRadius: 2,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <CascadeIcon 
            sx={{ 
              fontSize: 64, 
              color: 'primary.main',
              mb: 1
            }} 
          />
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
            Cascade
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Welcome back
          </Typography>
        </Box>

        {/* SSO Login */}
        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<MicrosoftIcon />}
          onClick={handleSsoLogin}
          sx={{ mb: 3 }}
        >
          Sign in with Microsoft
        </Button>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            Secure access to your meeting data
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
